import { TeamCategoryType } from "sh-models";
import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_SELECTED_TEAM_CATEGORY_TYPE', function setSelectedTeamCategoryType(selectedTeamCategoryType: TeamCategoryType) {
    teamSetupPickerStore.selectedTeamCategoryType = selectedTeamCategoryType;
});